<template>
  <import-data-view type="clinics" title="Клиники"></import-data-view>
</template>

<script>
    import ImportDataView from '@/components/import/ImportDataView';

    export default {
        components: {
            ImportDataView,
        },
    };
</script>


// WEBPACK FOOTER //
// src/pages/ui/ImportClinics.vue